import React from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import IconButton from '../BaseComponentWrappers/MotifIconButton';
import {labels} from '../../../util/utils';
import {financialStatementType} from '../../../util/uiconstants';
import {IconoirPlusCircle, IconoirPageEdit} from '@ey-xd/motif-icon';

export default function IconColumn(params) {
	const {value, onClick} = params;
	const financialStatement = useSelector((state) => state.financialStatement.byId[value]);

	const onClickIcon = (e) => {
		onClick && onClick(e, params.data?.id);
	};

	return (
		<StyledIconColumn
			className={`StyledIconColumn annotation-icon ${financialStatement?.isSelected ? 'selected' : 'notSelected'}
							${financialStatement?.annotations?.length <= 0 ? 'NoAnnotationsIcon' : 'YesAnnotationsIcon'}
							${typeof value === 'object' ? 'RowAnnotationsIcon' : 'NoRowAnnotationsIcon'}`}
		>
			{params.data?.financialStatementSubTypeId === financialStatementType.AccountClass ? (
				params.data.annotations.length > 0 ? (
					<IconButton iconTitle={labels.OARAnnotation} iconSource={IconoirPageEdit} onIconClick={onClickIcon} />
				) : (
					<IconButton iconTitle={labels.OARAnnotation} iconSource={IconoirPlusCircle} onIconClick={onClickIcon} />
				)
			) : (params.data?.financialStatementSubTypeId === financialStatementType.AccountType ||
					params.data?.financialStatementSubTypeId === financialStatementType.AccountSubType) &&
			  value ? (
				value.props?.children
			) : null}
		</StyledIconColumn>
	);
}

const StyledIconColumn = styled.section`
	display: flex;
	justify-content: center;
	align-items: center;
	min-width: var(--px-30);
	height: var(--px-30);
	&.NoAnnotationsIcon {
		&.selected,
		&:hover {
			background-color: var(--neutrals-200) !important;
			border-radius: var(--px-20);
			svg {
				margin: 0 var(--px-5);
				height: var(--px-20) !important;
				width: var(--px-20) !important;
				color: var(--neutrals-900);
			}
		}
		&.notSelected {
			&:hover {
				background-color: transparent !important;
			}
		}
	}
	.motif-button {
		width: var(--px-30);
		height: var(--px-30);
		cursor: pointer;
		.motif-icon {
			svg {
				margin: 0 var(--px-5);
				height: var(--px-20) !important;
				width: var(--px-20) !important;
				color: var(--neutrals-900);
			}
		}
	}
`;
